<template>
  <div class="ip-tips">
    <div class="tips-content" ref="popup">
      <i class="el-icon-close" @click="handleClose"></i>
      <div class="title" @mousedown="drag">
        温馨提示
      </div>
      <div class="tips">
        <div class="tip_font">
          <span>1.您的登陆ip异常，暂时不能登陆。</span>
          <span>2.请联系:13918034896，反馈您的问题。</span>
        </div>
      </div>
    </div>
  </div>
</div></template>

<script>

export default {
  props: {
    showIpWarning: { type: Boolean, default: false },
  },
  data() {
    return {

    }
  },

  methods: {
    handleClose() {
      console.log('aa')
      this.$emit("update:showIpWarning", false);
    },
    drag(e) {
      console.log(e);
      let disX = e.offsetX;
      let disY = e.offsetY;
      let _that = this;
      console.log(_that.$refs);
      document.onmousemove = function (e) {
        e.preventDefault();
        let l = e.clientX - disX;
        let t = e.clientY - disY;
        _that.$refs.popup.style.left = l + "px";
        _that.$refs.popup.style.top = t + "px";
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.ip-tips {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);

  .tips-content {
    position: absolute;
    top: 25%;
    left: 40%;
    width: 380px;
    height: 160px;
    background: #ffffff;
    box-shadow: 0px 6px 6px 0px rgba(14, 108, 172, 0.36);
    border-radius: 8px;

    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 25px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        color: #1b74af;
        transform: rotate(90deg);
      }
    }

    .title {
      cursor: pointer;
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #1b74af;
      height: 60px;
      line-height: 60px;
    }

    .tips {
      padding: 0 25px;

      .tip_font {
        text-align: left;
        font-size: 18px;
        // color: #797979;
        line-height: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/IpWarning.vue